export default __webpack_public_path__ + "static/media/gallery_01.95af2863.jpg";